module.exports = __webpack_public_path__ + "img/brighton-&-hove-albion-logo-icon.9f0db594.png";